import { Chip, Divider, Paper, Stack, Typography } from "@mui/material";
import { useMemo } from "react";
import { useSelector } from "react-redux";
import { RootState } from "../../../slices/Store";
import {
    getPhaseLastUpdateDateDiff,
    isHaltProject,
    toJalaliDate,
} from "../../../utils/date";

// updated
export default function ProjectDetailAddress() {
    const sharedState = useSelector((state: RootState) => state.shared);
    const projectDetailState = useSelector(
        (state: RootState) => state.projectDetail
    );
    const projectDetail = projectDetailState.projectDetail;

    const city = sharedState.baseInfo.cities.find(
        (c) => c.id === projectDetail.cityId
    );
    const region = city?.regions.find((c) => c.id === projectDetail.regionId);
    const subRegion = region?.subregions.find(
        (c) => c.id === projectDetail.subRegionId
    );
    const phase = sharedState.baseInfo.phaseList.find(
        (c) => c.id === projectDetail.phaseId
    );
    const addressFirstSection = projectDetail.address?.split("-")[0];

    const lastUpdateIsMoreThanMonth = useMemo(() => {
        const res = getPhaseLastUpdateDateDiff(
            projectDetail.phaseLastUpdateDate
        );

        if (res.type === "month") {
            return true;
        }

        return false;
    }, [projectDetail.phaseLastUpdateDate]);

    const lastShootingDate = useMemo(() => {
        return projectDetail.photos.at(0)?.shootingDate ?? "";
    }, []);

    return (
        <>
            <Paper sx={{ p: 1.5, mb: 1.5 }}>
                <Stack spacing={1.5}>
                    <Typography color="text.secondary">
                        {`${city.title} / ${region?.title} / ${addressFirstSection}`}
                    </Typography>

                    <Typography>{projectDetail.address}</Typography>

                    <Divider />

                    <Stack direction="row">
                        <Typography
                            fontSize="smaller"
                            color="text.secondary"
                            sx={{ flexGrow: 1 }}
                        >
                            تاریخ به روز رسانی پروژه
                        </Typography>

                        <Typography color="text.secondary">
                            {toJalaliDate(projectDetail.lastUpdateDate)}
                        </Typography>
                    </Stack>

                    <Stack direction="row">
                        <Typography
                            fontSize="smaller"
                            color="text.secondary"
                            sx={{ flexGrow: 1 }}
                        >
                            تاریخ آخرین عکس
                        </Typography>

                        <Typography color="text.secondary">
                            {toJalaliDate(lastShootingDate)}
                        </Typography>
                    </Stack>
                </Stack>
            </Paper>

            <Stack
                direction="row"
                spacing={0.5}
                justifyContent="center"
                flexWrap="wrap"
                alignItems="center"
                sx={{ fontSize: 12, mb: 1.5, color: "text.secondary" }}
            >
                {lastUpdateIsMoreThanMonth ? (
                    <>
                        {isHaltProject(projectDetail.phaseLastUpdateDate) && (
                            <Chip
                                size="small"
                                color="error"
                                label="پروژه متوقف"
                            />
                        )}

                        <Typography
                            color="inherit"
                            fontSize="inherit"
                        >
                            این پروژه به مدت
                        </Typography>

                        <Typography
                            fontSize="inherit"
                            color={
                                isHaltProject(projectDetail.phaseLastUpdateDate)
                                    ? "error"
                                    : "primary"
                            }
                        >
                            {
                                getPhaseLastUpdateDateDiff(
                                    projectDetail.phaseLastUpdateDate
                                ).description
                            }
                        </Typography>

                        <Typography
                            color="inherit"
                            fontSize="inherit"
                        >
                            است که در مرحله
                        </Typography>

                        <Typography
                            fontSize="inherit"
                            color="secondary"
                        >
                            {phase?.title}
                        </Typography>

                        <Typography
                            color="inherit"
                            fontSize="inherit"
                        >
                            قرار دارد
                        </Typography>
                    </>
                ) : (
                    <>
                        <Typography
                            color="inherit"
                            fontSize="inherit"
                        >
                            این پروژه
                        </Typography>

                        <Typography
                            fontSize="inherit"
                            color="primary"
                        >
                            کمتر از یک ماه
                        </Typography>

                        <Typography
                            color="inherit"
                            fontSize="inherit"
                        >
                            است که در مرحله
                        </Typography>

                        <Typography
                            fontSize="inherit"
                            color="secondary"
                        >
                            {phase?.title}
                        </Typography>

                        <Typography
                            color="inherit"
                            fontSize="inherit"
                        >
                            قرار دارد.
                        </Typography>
                    </>
                )}
            </Stack>
        </>
    );
}
